var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import defaultPalette from '../palette';
import defaultTypography from '../theme/typography';
/* Contained Button Styles */
// Contained Vitality
export var getContainedVitality = function (palette) {
    var _a, _b, _c, _d, _e, _f;
    return {
        border: "1px solid " + ((_a = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _a === void 0 ? void 0 : _a.main),
        color: (_b = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _b === void 0 ? void 0 : _b.contrastText,
        backgroundColor: (_c = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _c === void 0 ? void 0 : _c.main,
        '&:hover, &:active': {
            color: (_d = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _d === void 0 ? void 0 : _d.contrastText,
            backgroundColor: (_e = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _e === void 0 ? void 0 : _e.light,
            border: "1px solid " + ((_f = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _f === void 0 ? void 0 : _f.light),
        },
        '&$disabled': {
            color: palette === null || palette === void 0 ? void 0 : palette.primary[200],
            backgroundColor: palette === null || palette === void 0 ? void 0 : palette.vitality[100],
            border: "1px solid " + (palette === null || palette === void 0 ? void 0 : palette.vitality[100]),
        },
    };
};
// Contained Default
var getContainedDefault = function (palette) {
    var _a, _b, _c, _d, _e, _f;
    return {
        color: (_a = palette === null || palette === void 0 ? void 0 : palette.core) === null || _a === void 0 ? void 0 : _a.contrastText,
        backgroundColor: (_b = palette === null || palette === void 0 ? void 0 : palette.common) === null || _b === void 0 ? void 0 : _b.white,
        border: "1px solid " + ((_c = palette === null || palette === void 0 ? void 0 : palette.core) === null || _c === void 0 ? void 0 : _c.main),
        '&:hover, &:active': {
            color: (_d = palette === null || palette === void 0 ? void 0 : palette.core) === null || _d === void 0 ? void 0 : _d.contrastText,
            backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[100],
            border: "1px solid " + ((_e = palette === null || palette === void 0 ? void 0 : palette.core) === null || _e === void 0 ? void 0 : _e.main),
        },
        '&$disabled': {
            color: palette === null || palette === void 0 ? void 0 : palette.primary[200],
            backgroundColor: (_f = palette === null || palette === void 0 ? void 0 : palette.common) === null || _f === void 0 ? void 0 : _f.white,
            border: "1px solid " + (palette === null || palette === void 0 ? void 0 : palette.core[200]),
        },
    };
};
// Contained Secondary
var getContainedSecondary = function (palette) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        color: (_a = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _a === void 0 ? void 0 : _a.contrastText,
        backgroundColor: (_b = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _b === void 0 ? void 0 : _b.main,
        border: "1px solid " + ((_c = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _c === void 0 ? void 0 : _c.main),
        '&:hover, &:active': {
            color: (_d = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _d === void 0 ? void 0 : _d.contrastText,
            backgroundColor: (_e = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _e === void 0 ? void 0 : _e.dark,
            border: "1px solid " + ((_f = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _f === void 0 ? void 0 : _f.dark),
        },
        '&$disabled': {
            color: (_g = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _g === void 0 ? void 0 : _g.contrastText,
            backgroundColor: (_h = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _h === void 0 ? void 0 : _h.light,
            border: "1px solid " + ((_j = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _j === void 0 ? void 0 : _j.light),
        },
    };
};
/* Text Button Styles */
// Text Default
export var getTextDefault = function (palette) {
    var _a, _b;
    return {
        // We want to default to using "primary" color for Default Text Button
        color: (_a = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _a === void 0 ? void 0 : _a.main,
        '&:hover, &:active': {
            color: (_b = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _b === void 0 ? void 0 : _b.light,
        },
        '&&&$disabled': {
            color: palette === null || palette === void 0 ? void 0 : palette.primary[100],
        },
    };
};
// Text Secondary
var getTextSecondary = function (palette) {
    var _a, _b;
    return {
        color: (_a = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _a === void 0 ? void 0 : _a.main,
        '&:hover, &:active': {
            color: (_b = palette === null || palette === void 0 ? void 0 : palette.secondary) === null || _b === void 0 ? void 0 : _b.dark,
        },
        '&&&$disabled': {
            color: palette.secondary.light,
        },
    };
};
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b, _c = _a.typography, typography = _c === void 0 ? defaultTypography : _c;
    var iconSize = {
        '& > *:first-child': {
            fontSize: typography
                ? typography.pxToRem(typography === null || typography === void 0 ? void 0 : typography.fontSize)
                : 16,
        },
    };
    return {
        MuiButton: {
            root: __assign(__assign({}, typography === null || typography === void 0 ? void 0 : typography.body1), { borderRadius: 24, '&&': {
                    fontWeight: '400',
                }, '&&, &&:hover, &&:active, &&$disabled, &&:focus': {
                    boxShadow: 'none',
                }, '&&:focus-visible': {
                    outline: "3px solid " + palette.primary.main,
                } }),
            sizeSmall: __assign({}, typography === null || typography === void 0 ? void 0 : typography.body2),
            text: __assign({}, getTextDefault(palette)),
            textSecondary: getTextSecondary(palette),
            contained: __assign(__assign({}, getContainedDefault(palette)), { '&.MuiButton-containedVitality': getContainedVitality(palette) }),
            containedSecondary: getContainedSecondary(palette),
            containedVitality: {},
            iconSizeSmall: iconSize,
            iconSizeMedium: iconSize,
            iconSizeLarge: iconSize,
        },
    };
});
